exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-stats[data-v-2706fc99] {\n    position: relative;\n}\n.card-stats > .fa-sync[data-v-2706fc99] {\n    position: absolute;\n    right: 10px;\n    bottom: 5px;\n    color: white;\n    opacity: 0.3;\n    font-size: 1.5em;\n    animation: rotate-2706fc99 2s linear infinite;\n}\n@keyframes rotate-2706fc99 {\n0% {\n        transform: rotate(0deg);\n}\n100% {\n        transform: rotate(360deg);\n}\n}\n", ""]);

// exports
